import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone } from 'lucide-react';
import { Button } from './ui/button';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'Services', path: '/services' },
    { name: 'Book Now', path: '/book' },
    { name: 'Reviews', path: '/reviews' },
    { name: 'Contact', path: '/contact' },
  ];

  const isActiveLink = (path) => location.pathname === path;

  return (
    <header className="bg-white shadow-lg sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3">
            <img 
	      src="https://customer-assets.emergentagent.com/job_car-shield/artifacts/63m1j3ix_image.png"
              alt="Texas Tint Studio" 
              className="h-12 w-12 rounded-full object-cover"
            />
            <div className="text-xl font-bold text-red-600">
              Texas Tint Studio
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            {navLinks.map((link) => (
              <Link
                key={link.name}
                to={link.path}
                className={`text-lg font-medium transition-colors duration-200 hover:text-red-600 ${
                  isActiveLink(link.path)
                    ? 'text-red-600 border-b-2 border-red-600 pb-1'
                    : 'text-gray-700'
                }`}
              >
                {link.name}
              </Link>
            ))}
          </nav>

          {/* Call Button */}
          <div className="hidden md:flex items-center space-x-4">
            <a 
              href="tel:(713)446-8928" 
              className="flex items-center space-x-2 text-gray-700 hover:text-red-600 transition-colors"
            >
              <Phone className="h-4 w-4" />
              <span className="font-medium">(713) 446-8928</span>
            </a>
            <Button 
              asChild
              className="bg-red-600 hover:bg-red-700 text-white px-6 py-2 rounded-lg transition-all duration-200 hover:shadow-lg"
            >
              <Link to="/contact">Get Quote</Link>
            </Button>
          </div>

          {/* Mobile menu button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden p-2 rounded-md text-gray-700 hover:text-red-600 transition-colors"
          >
            {isMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden border-t border-gray-200 py-4">
            <nav className="flex flex-col space-y-4">
              {navLinks.map((link) => (
                <Link
                  key={link.name}
                  to={link.path}
                  onClick={() => setIsMenuOpen(false)}
                  className={`text-lg font-medium transition-colors duration-200 hover:text-red-600 ${
                    isActiveLink(link.path) ? 'text-red-600' : 'text-gray-700'
                  }`}
                >
                  {link.name}
                </Link>
              ))}
              <div className="pt-4 border-t border-gray-200">
                <a 
                  href="tel:(713)446-8928" 
                  className="flex items-center space-x-2 text-gray-700 hover:text-red-600 transition-colors mb-4"
                >
                  <Phone className="h-4 w-4" />
                  <span className="font-medium">(713) 446-8928</span>
                </a>
                <Button 
                  asChild
                  className="bg-red-600 hover:bg-red-700 text-white px-6 py-2 rounded-lg w-full transition-all duration-200 hover:shadow-lg"
                >
                  <Link to="/contact">Get Quote</Link>
                </Button>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
